import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { initializeAnalytics } from './plugins/analytics'
import { useAnalytics } from './composables/useAnalytics'

async function bootstrap() {
  try {
    await initializeAnalytics()
    
    const app = createApp(App)

    const analytics = useAnalytics()
    await analytics.trackPageView('/', 'PDFGen - Home')

    app.config.globalProperties.$analytics = analytics

    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize analytics:', error)
    const app = createApp(App)
    app.mount('#app')
  }
}

bootstrap()
